// eslint-disable-next-line import/prefer-default-export
export const requestStatuses = {
  REQUESTED: 'requested',
  ACCEPTED: 'accepted',
  DECLINED: 'declined',
};
